import {CoreGraphNodeId} from '../../../../../@polygonjs/polygonjs/src/core/graph/CoreGraph';

export interface EditorClipboardState {
	node_id: CoreGraphNodeId | null;
	param_id: CoreGraphNodeId | null;
	upload_name: string | null;
}

export enum EditorClipboardMutation {
	NODE_ID = 'NODE_ID',
	PARAM_ID = 'PARAM_ID',
	UPLOAD_NAME = 'UPLOAD_NAME',
}

type EditorClipboardPayloadByMutationMapGeneric = {[key in EditorClipboardMutation]: any};
export interface EditorClipboardPayloadByMutationMap extends EditorClipboardPayloadByMutationMapGeneric {
	// scene
	[EditorClipboardMutation.NODE_ID]: CoreGraphNodeId;
	[EditorClipboardMutation.PARAM_ID]: CoreGraphNodeId;
	[EditorClipboardMutation.UPLOAD_NAME]: string | null;
}

export const EditorClipboardStateModule = {
	namespaced: true,
	state(): EditorClipboardState {
		return {
			node_id: null,
			param_id: null,
			upload_name: null,
		};
	},

	// getters: {
	// 	upload_name(state:EditorClipboardState) {
	// 		return state.upload_name;
	// 	},
	// 	param(state) {
	// 		return state.param;
	// 	},
	// },

	mutations: {
		[EditorClipboardMutation.NODE_ID]: (
			state: EditorClipboardState,
			payload: EditorClipboardPayloadByMutationMap[EditorClipboardMutation.NODE_ID]
		) => {
			state.node_id = payload;
		},
		[EditorClipboardMutation.PARAM_ID]: (
			state: EditorClipboardState,
			payload: EditorClipboardPayloadByMutationMap[EditorClipboardMutation.PARAM_ID]
		) => {
			state.param_id = payload;
		},
		[EditorClipboardMutation.UPLOAD_NAME]: (
			state: EditorClipboardState,
			payload: EditorClipboardPayloadByMutationMap[EditorClipboardMutation.UPLOAD_NAME]
		) => {
			state.upload_name = payload;
		},
		// [EditorClipboardMutation.UPLOAD_NAME]: (state: EditorClipboardState, payload: string) => {
		// 	state.upload_name = payload;
		// },
	},
};
